export default "__VITE_ASSET__LnP5V88V__"